import {TimelineLite, TweenLite} from "gsap";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborSymbol} from "../../reels/PearlHarborSymbol";

export class PearlHarborResizeArea implements SimplePresentationRunner {
    private _mainTL: TimelineMax;
    private _controller: SimplePresentationRunnerController;

    private complete(): void {
        this._controller.finish();
    }

    shouldRun(): boolean {
        const isRestore: boolean = PearlHarbor.model.isRestore;
        let hasTarget: boolean = false,
            hasBigSymbol: boolean = false;
        if (isRestore) {
            return false;
        } else {
            hasTarget = !PearlHarbor.model.isRestore && PearlHarbor.model.targetSymbolPos.length > 0;
            hasBigSymbol = PearlHarbor.model.gameData.bigSymPresent;
        }
        return hasTarget || hasBigSymbol;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._mainTL = new TimelineLite();
        const border: number[] = [13, 0, 6, 0];
        if (PearlHarbor.model.targetSymbolPos.length > 0) {
            const targetPos: number[] = PearlHarbor.model.targetSymbolPos;
            let symbol: PearlHarborSymbol = <PearlHarborSymbol>PearlHarbor.allReelsView.mainReelModels[targetPos[0]].reelView.getTargetSymbol();

            border[0] = Math.min(symbol.reelTargetPosition, border[0]);
            border[1] = Math.max(Math.floor(symbol.reelTargetPosition + 1), border[1]);
            border[2] = Math.min(Math.floor(symbol.reelId), border[2]);
            border[3] = Math.max(Math.floor(symbol.reelId), border[3]);
        }
        if (PearlHarbor.model.gameData.bigSymPresent) {
            PearlHarbor.model.bigSymsResponse.topLeftSeedLanding.forEach((pos: number, i: number) => {
                border[0] = Math.min(pos % 14, border[0]);
                border[1] = Math.max(Math.floor(pos % 14) + PearlHarbor.model.bigSymsResponse.sizeRowLanding[i] * 2 - 1, border[1]);
                border[2] = Math.min(Math.floor(pos / 14), border[2]);
                border[3] = Math.max(Math.floor(pos / 14) + PearlHarbor.model.bigSymsResponse.sizeReelLanding[i] - 1, border[3]);
            });
        }
        this._mainTL.add(PearlHarbor.activeSymbolsBackground.updateActiveArea(border), 0.1);
        if (this._mainTL.duration() == 0) {
            this._mainTL.add(TweenLite.to(this, {duration: 0.001}));
        }
        this._mainTL.add(() => this.complete());
    }
}